import { z } from "zod";
import { capitalize } from "../../strings";

export const addUserFormSchema = z.object({
	firstName: z.string().min(1, "First name is required").transform(capitalize),
	lastName: z.string().min(1, "Last name is required").transform(capitalize),
	email: z.email(),
	teamIds: z.array(z.uuid()).default([]),
	// Optional: every non-owner receives the `member` system role at joining, so the base
	// permission set is guaranteed and the picker only names the roles a person carries on top.
	roleIds: z.array(z.uuid()).default([]),
});

export type AddUserFormSchema = z.infer<typeof addUserFormSchema>;
